<template>
    <alert-modal
        @close="close"
        class="cz2__pet-packs-info"
    >
        <custom-swiper
            :show-mask="false"
            :space-between="0"
            :has-mobile-bullets="true"
            class="cz2__pet-packs-carousel"
        >
            <template v-slot:slides>
                <img
                    v-for="item in packImages"
                    :key="item.image"
                    :src="item.image"
                    :alt="item.alt"
                    height="219"
                    width="auto"
                    class="swiper-slide"
                >
            </template>
        </custom-swiper>

        <div class="cz2__pet-packs-content">
            <h1 class="cz2__modal-popup__header">
                {{ $t('PET_PACK_MODAL_TITLE') }}
            </h1>

            <p class="cz2__modal-popup__copy">
                {{ $t('PET_PACK_MODAL_COPY') }}
            </p>

            <p class="cz2__modal-popup__copy cz2__pet-packs-price">
                {{ price }}
            </p>

            <pet-pack-add-remove-button
                :show-price="false"
                :large-text="true"
            />
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__pet-packs-info {
            .cz2__modal-popup {
                flex-direction: column;
            }

            .cz2__modal-popup__body {
                padding: 0;
            }

            .cz2__modal-popup__close {
                z-index: 10;
            }

            .cz2__pet-packs-carousel {
                max-height: 380px;
                padding-bottom: 32px;
                background-color: #F5F5F5;

                .swiper-container-outer,
                .swiper-container {
                    margin: 0;
                    height: 100%;
                    width: 100%;
                }

                .swiper-slide {
                    object-fit: contain;
                }
            }

            // Fix carousel height in Firefox
            .swiper-container-outer,
            .swiper-container,
            .swiper-wrapper {
                max-height: 360px;
            }
            .swiper-slide {
                height: auto;
            }

            .cz2__warning-modal,
            .cz2__modal-popup__header {
                text-align: left;
            }

            .cz2__pet-packs-content {
                padding: 32px;
                padding-top: 24px;
            }

            .cz2__pet-packs-price {
                margin: 8px 0 24px 0;
                font-size: 20px;
                font-weight: bold;
            }

            .cz2__btn,
            .cz2__btn:hover {
                height: 48px;
                font-size: 22px !important;
            }

            .cz2__btn:hover {
                &::before {
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                }
            }

            .cz2__modal-popup__close {
                &:after {
                    background: transparent url(../assets/icons/close-round.svg) no-repeat center/contain;
                }
            }

            // Swiper
            .swiper-custom-arrow {
                &.has-mobile-bullets {
                    top: 100%;

                    background-image: url(../assets/icons/chevron.svg) !important;
                    background-color: transparent;
                    width: 24px;

                    &.swiper-custom-arrow--left {
                        transform: rotate(180deg);
                        right: calc(100% - 48px);
                    }
                    &.swiper-custom-arrow--right {
                        transform: none;
                        left: calc(100% - 48px);
                    }
                }

                &:focus {
                    border: none;
                }
            }

            .swiper-custom-bullets {
                margin-top: 0;
                gap: 16px;
            }

            .swiper-custom-bullets__bullet {
                width: 8px;
                height: 8px;

                &:before {
                    display: none;
                }

                &:after {
                    top: 0;
                    left: 0;
                    border: 1px solid #707070;
                    width: 8px;
                    height: 8px;
                    background-color: white;
                }

                &.swiper-custom-bullets__bullet--active:after {
                    background-color: black;
                }
            }

            @include respond-below-height(short) {
                .cz2__pet-packs-carousel {
                    max-height: 300px;
                    padding-top: 16px;
                }
            }
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';
    import CustomSwiper from './ui/CustomSwiper.vue';
    import PetPackAddRemoveButton from './PetPackAddRemoveButton.vue';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            AlertModal,
            CustomSwiper,
            PetPackAddRemoveButton,
        },

        computed: {
            options() {
                return this.$store.state.customizer.options;
            },

            customAttributes() {
                return this.$store.state.customizer.viewController.blueprint.custom;
            },

            availableBuddyPack() {
                return this.$store.getters.availableBuddyPack;
            },

            packImages() {
                const custom = this.availableBuddyPack?.custom;
                const packImages = [];

                for (let i = 1; i <= 5; i += 1) {
                    if (custom[`fun-modal-${i}-image`]) {
                        packImages.push({
                            image: custom[`fun-modal-${i}-image`],
                            alt: custom[`fun-modal-${i}-image-alt`],
                        });
                    }
                }

                return packImages;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            price() {
                if (this.availableBuddyPack) {
                    const price = this.viewController.getPrice(this.availableBuddyPack);

                    return formatPrice(this.$store.state, price, 'noDigits', false);
                }

                return '';
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showPetPackInfoModal', false);
            },
        },
    };
</script>
